import React from 'react'
import Shorten from '../../helper/shorten'
import Milliseconds from '../../helper/milliseconds'
import { TraceDiffItem } from '../../domain/Trace'

interface Props {
    stats: TraceDiffItem
}
interface State {}

export class DiffItem extends React.Component<Props, State> {
    public diffLabel(type) {
        switch (type) {
            case 'changed':
                return <span className="fa fa-circle-o text-warning" title="Call exists in base and target" />
            case 'removed':
                return <span className="fa fa-minus-circle text-danger" title="Call exists only in target" />
            case 'added':
                return <span className="fa fa-plus-circle text-success" title="Call exists only in base" />
        }
    }

    public render() {
        const { stats } = this.props

        return (
            <tr key={stats.call + '-foo'}>
                <td>{this.diffLabel(stats.type)}</td>
                <td>
                    <div className={'category category-' + stats.cat}>{stats.cat}</div>
                </td>
                <td>
                    <Shorten string={stats.call} />
                </td>
                <td className="number">
                    <Milliseconds value={stats.wt} />
                </td>
                <td className="number">
                    <Milliseconds value={stats.excl_wt} />
                </td>
            </tr>
        )
    }
}
